import {
  BlockNoteEditor,
  createExtension,
  isTableCellSelection,
} from '@blocknote/core';
import { Plugin, PluginKey, Selection } from 'prosemirror-state';
import { BlockSchema, FurtherBlockNoteExtensionContext } from '../schema';

const pluginKey = new PluginKey('disableTableCellSelectionInReadonly');

export function clearTableCellSelectionIfPresent(
  editor: BlockNoteEditor<BlockSchema>,
) {
  editor.exec((state, dispatch) => {
    if (!dispatch || !isTableCellSelection(state.selection)) {
      return false;
    }

    dispatch(
      state.tr.setSelection(Selection.near(state.selection.$anchorCell, 1)),
    );
    return true;
  });
}

export const disableTableCellSelectionInReadonlyExtension = createExtension(
  ({ editor }: FurtherBlockNoteExtensionContext) => ({
    key: 'disableTableCellSelectionInReadonly',
    prosemirrorPlugins: [
      createDisableTableCellSelectionPlugin(() => !editor.isEditable),
    ],
  }),
);

function createDisableTableCellSelectionPlugin(isReadOnly: () => boolean) {
  return new Plugin({
    key: pluginKey,
    appendTransaction(_transactions, _oldState, newState) {
      if (!isReadOnly() || !isTableCellSelection(newState.selection)) {
        return null;
      }

      return newState.tr.setSelection(
        Selection.near(newState.selection.$anchorCell, 1),
      );
    },
    props: {
      handleDOMEvents: {
        mousedown(_view, event) {
          if (!isReadOnly()) {
            return false;
          }

          if (event.shiftKey) {
            event.preventDefault();
            return true;
          }

          return false;
        },
      },
    },
  });
}
